<template>
  <div class="test-list">
    <!-- 进度 -->
    <div class="progress" :style="{width: progress}"></div>
    <!-- 开始 -->
    <div v-if="show_body && ctype == 1">
      <div class="item-answer-left-animation item-inter inter-left pd32 clearfix">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>嗨！{{nickname}}，你好，欢迎进入职业发展健康指数测评！</p>
            <p class="pd-row-2">接下来我会分三个部分来帮助你评测当下状态，预计需要时长12分钟，答案没有对错之分，请根据自己的实际情况作答，然后我会为你生成专属职业健康度报告，让你客观、清晰的了解自己。</p>
            <p class="pd-row-2">如果你准备好了，点击下方按钮，我们开始吧！</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
      <div class="item-answer-right-animation item-inter inter-right mt32 clearfix">
        <div class="pull-right ico-box">
          <img :src="headimgurl" alt="" />
        </div>
        <div class="item-text pull-right pr">
          <div @click="startTest" class="alert-con item-radius pb-public">
            <strong><span class="active_a">开始评测</span></strong>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <div ref="topic-header">
      <!-- 第一部分 头部 -->
      <div v-if="ctype == 1 && !lock" :class="[ctype == 1 ? 'item-answer-left-animation' : '','item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>第一部分：评估你的工作幸福感</p>
            <p class="pd-row-2">幸福感是指在工作中自己的需要是否能得到满足、潜能是否能得到发挥、力量是否能得以增长，并能获得持续快乐的体验，简而言之，就是工作干的“是否开心”。</p>
            <p class="pd-row-2">预计4分钟完成，请根据真实情况作答。</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
      <!-- 第二部分 头部 -->
      <div v-if="ctype == 2 && !lock" :class="[ctype == 2 ? 'item-answer-left-animation' : '','item-inter inter-left pd32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>第二部分：评估你的工作掌控感</p>
            <p class="pd-row-2">反应的是你对自身是否能够胜任当前工作的信心程度，直接感受就是工作做得“是否顺手”。</p>
            <p class="pd-row-2">预计4分钟完成，请根据真实情况作答。</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
      <!-- 第三部分 头部 -->
      <div v-if="ctype == 3 && !lock" :class="[ctype == 3 ? 'item-answer-left-animation' : '','item-inter inter-left pd32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>第三部分：评估你的心智成熟度</p>
            <p class="pd-row-2">是指职业信念上的成熟程度，反映的是你在心智方面“是否掉坑”。</p>
            <p class="pd-row-2">此部分为最后一步，马上就要大功告成，加油！预计用时4分钟，请根据真实情况作答。</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- list -->
    <div v-for="(item, index) in list" :key="index+''">
      <!-- 数据渲染部分 -->
      <div ref="item-yield" v-show="yieldIndex + 2 >= index">
        <div :class="[yieldIndex >= index && !lock ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
          <div class="pull-left ico-box">
            <img src="../../../assets/cep_logo.png" alt="" />
          </div>
          <div class="item-text pull-left pr">
            <div class="alert-con item-radius">
              <p>{{item.question}}</p>
            </div>
            <div class="caret pa"></div>
          </div>
        </div>
        <!-- item-right -->
        <div :class="[yieldIndex >= index && !lock ? 'item-answer-right-animation' : '','item-inter inter-right pt32']">
          <div class="clearfix">
            <div class="pull-right ico-box">
              <img :src="headimgurl" alt="" />
            </div>
            <div class="item-text pull-right pr">
              <div class="alert-con item-radius">
                <van-radio-group class="alert-radio-group" v-model="item.radio">
                  <van-cell-group>
                    <van-cell v-for="item2 in item.options" :key="item[1]" :class="item.radio == item2[1] ? 'active' : ''" :title="item2[0]" clickable @click="selectItemRadio(item, item2, index)">
                      <van-radio :checked-color="'#EB5032'" :name="item2[1]" />
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div class="caret pa"></div>
              <div v-if="yieldIndex < index && !lock" class="shelter"></div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
    <!-- 结束 -->
    <div v-show="showFooter">
      <div ref="cart-footer" v-if="ctype == 1" :class="[showFooter? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>恭喜完成第一部分，掌控感指数报告正在生成中…</p>
            <p @click="saveReportHandle()" class="text-right next-box">开启第二部分 > </p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
      <div ref="cart-footer" v-if="ctype == 2" :class="[showFooter ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>恭喜完成第二部分，掌控感指数报告正在生成中…</p>
            <p @click="saveReportHandle()" class="text-right next-box">开启第三部分 > </p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
      <div ref="cart-footer" v-if="ctype == 3" :class="[showFooter ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>恭喜，你已完成全部测评</p>
            <p>请点击领取你的「职业健康指数测评」报告！</p>
            <p @click="saveReportHandle()" class="text-right next-box">领取报告 > </p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- 填写个人资料 -->
    <div v-if="userInfoBool" :class="['save-userinfo',userInfoBool?'on':'']">
      <div class="u-title">个人信息提交</div>
      <div>
        <div v-for="(item,index) in Object.keys(extraObj)" :class="['u-input',(item=='_interest' || item=='_identity')?'on':'']">
          <label  :class="[(item=='_interest' || item=='_identity')?'interest-label':'']"  v-html="textToHtml(extraObj[item])"></label>
          <div class="ra" v-if="item=='_interest'">
            <!-- 多选 -->
            <van-radio-group   v-model="extra[item]" >
              <van-radio  :class="['radio',true?'on':false]" checked-color="#eb5032"   :name="'不想了解'">不想了解</van-radio>
              <van-radio  :class="['radio',true?'on':false]" checked-color="#eb5032"   :name="'有点感兴趣'">有点感兴趣</van-radio>
              <van-radio  :class="['radio',true?'on':false]" checked-color="#eb5032"   :name="'非常感兴趣'">非常感兴趣</van-radio>
            </van-radio-group>
          </div>
          <div class="ra" v-else-if="item=='_identity'">
            <!-- 多选 -->
            <van-radio-group   v-model="extra[item]" >
              <van-radio  :class="['radio',true?'on':false]" checked-color="#eb5032"   :name="'在校学生'">在校学生</van-radio>
              <van-radio  :class="['radio',true?'on':false]" checked-color="#eb5032"   :name="'已毕业/已就业'">已毕业/已就业</van-radio>
            </van-radio-group>
          </div>
          <input v-else type="text" v-model="extra[item]" :placeholder="'请输入'+extraObj[item]" />
        </div>
      </div>
      <!--  -->
      <a class="u-btn" @click="over_click()">提交</a>
    </div>
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop">
        <img src="../../../assets/cep_ewm.png" alt="" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  measurement_index,
  measurement_answer,
  get_extra_info,
  ceping44_extra,
  ceping44_save_extra
} from '@/api/measurement'
import { phoneValidation} from '@/utils/validation'
import { queryString } from '@/utils/tools'
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
      return {
        show_body: false,
        //
        lock: true,
        //
        yieldIndex: 0,
        // 状态
        ctype: 1,
        //
        headimgurl: "",
        headtitle: "职业发展健康指数测评",
        nickname: "",
        list: [],
        showFooter: false,
        kc_show: false,
        data: {},
        // 
        extra:{},
        extraObj:{},
        userInfoBool:false,
      }
    },
    computed: {
      progress() {
        return Math.floor((this.yieldIndex / (this.list.length - 1)) * 100) + '%';
      },
      // 文字换行
      textToHtml(){
        return function(text){
          let arr = text.split('')
          arr =  arr.map((v,index)=>{
            // return index==3?v+'<br/>':
            return ((index==arr.length-1)?v+'：':v)
          });
          return arr.join('');
        }
      }
    },
    methods: {
      selectItemRadio(item, item2, index) {

        // 如果没有选择
        let isLastEl = (index + 1) < this.list.length;
        if (!item.radio && isLastEl) {
          this.yieldIndex++;
          this.setScrollTo(index);
        }
        // 最后一个
        if (!item.radio && !isLastEl) {
          this.showFooter = true;
          let el = this.$refs['cart-footer'];
          this.setScrollTo(false, true, el)
        }

        // 赋值
        item.radio = item2[1];
        let is_complete = (index==this.list.length-1) && (this.ctype == 3) ? true : false;

        this.$forceUpdate();

        // 神策统计--选择选项时触发
        sensors.track('doQuestions', {
          evaluation_id: this.$route.query.cid,
          evaluation_name: this.data.headtitle,
          questions_number: this.data.progress+=1,
          questions_topic: item.question,
          questions_option: item2[0],
          is_complete_question: is_complete,
          share_user_id: this.$route.query.share_uid?this.$route.query.share_uid:"",
          channel_name: this.$route.query.channel?this.$route.query.channel:""
        })
      },
      setScrollTo(index, bool, el) {
        setTimeout(() => {
          let elTop = bool ? el.offsetTop - 10 : this.$refs['item-yield'][index + 1].offsetTop - 10;
          let scroll = document.documentElement.scrollTop ? document.documentElement : document.body;
          // window.scrollTo(0, elTop);
          // window.scrollTo({
          //     top: elTop,
          //     behavior: "smooth"
          // });
          this.scrollSmoothTo(elTop);
        }, 100)
      },
      scrollSmoothTo(position) {
        if (!window.requestAnimationFrame) {
          window.requestAnimationFrame = function(callback, element) {
            return setTimeout(callback, 17);
          };
        }
        // 当前滚动高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // 滚动step方法
        var step = function() {
          // 距离目标滚动距离
          var distance = position - scrollTop;
          // 目标滚动位置
          scrollTop = scrollTop + distance / 5;
          if (Math.abs(distance) < 1) {
            window.scrollTo(0, position);
          } else {
            window.scrollTo(0, scrollTop);
            requestAnimationFrame(step);
          }
        };
        step();
      },
      startTest() {
        setTimeout(() => {
          this.lock = false;
          let el = this.$refs['topic-header'];
          this.setScrollTo(0, true, el);
        }, 50)
      },
      createData() {
        let arr = [];
        for (let arg of this.list) {
          arr.push({
            qid: arg.id,
            cid: arg.cid,
            eid: arg.eid,
            score: arg.radio
          })
        }
        return arr
      },
      /*
       *@param: arr
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        let bool = true;
        get_extra_info().then(data=>{
          for(let i=0;i<Object.keys(this.extraObj).length;i++){
            let item = Object.keys(this.extraObj)[i];
            if(data.extra[item]){
              this.extra[item] = data.extra[item];
            }else{
              bool = false;

            }
          }
          if(bool){
            this.over_click();
          }else{
            this.userInfoBool = true;
          }
        });
      },
      over_click() {
        let q = this.$route.query;
        let result = this.createData();
        let obj = {};
         for(let i=0;i<Object.keys(this.extraObj).length;i++){
          let item = Object.keys(this.extraObj)[i];
          if(!this.extra[item]){
            this.$toast(`${this.extraObj[item]}不能为空！`);
            return
          }else if(!phoneValidation(this.extra.phone)){
            this.$toast('手机号格式不正确！');
            return
          }else{
            obj[item] = this.extra[item];
          }
        }
        ceping44_save_extra(obj).then((data) => {
          if(data.code==10002){
            this.$toast(data.data.msg || data.msg);
            return
          }
        });
        measurement_answer({
          cid: q.cid,
          ctype: this.ctype,
          answer: JSON.stringify(result)
        }).then((data) => {
            this.userInfoBool = false;
            if (this.ctype == 3) {
              if (data.subscribe || !data.need_subscribe) {
                let q = this.$route.query;
                this.$router.push({
                  path: '/measurement_report',
                  query: {
                    cid: q.cid,
                    uid: data.uid
                  }
                })
              } else {
                this.kc_show = true;
              }
            } else {
              // 全部重置
              this.show_body = false;
              this.lock = true;
              this.yieldIndex = 0;
              // 状态
              this.ctype = 1;
              this.headimgurl = "";
              this.headtitle = "职业发展健康指数测评";
              this.nickname = "";
              this.list = [];
              this.kc_show = false;
              this.showFooter = false;
              // 啦
              this.pullData();
            }
          })
      },
      pullData() {
        measurement_index({
            cid: this.$route.query.cid
          })
          .then((data) => {
            if (typeof data !== 'string') {
              this.ctype = data.ctype;
              this.data = data;
              this.headimgurl = data.headimgurl;
              this.headtitle = data.headtitle;
              this.nickname = data.nickname;

              // 获取信息收集字段
              ceping44_extra().then(res=>{
                this.extraObj = res.extra;
              });
              
              //
              for (let arg of data.list) {
                arg.show = false;
                arg.radio = 0;
              }
              this.list = data.list;
              this.show_body = true;
              if (this.ctype != 1) {
                this.list[0].show = true;
                this.lock = false;
              };
              // 神策统计--打开页面时触发
            sensors.track('evaluationPage', {
              evaluation_id: this.$route.query.cid,
              evaluation_name: this.data.headtitle,
              evaluation_url: window.location.href,
              evaluation_page_title: this.data.headtitle,
              share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              channel_name: this.$route.query.channel ? this.$route.query.channel : ""
            })

            } else {
              let cid = queryString(data, 'cid');
              let uid = queryString(data, 'uid');
              // 已经测评完成
              this.$router.push({
                path: '/measurement_report',
                query: {
                  cid,
                  uid
                }
              })
            }
          })
      }
    },
    created() {
      this.pullData();
      shareCon("measurement",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.save-userinfo{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  overflow: auto;
  z-index:888;
  .u-title{
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input{
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    label{
      display: block;
      width: 150px;
      text-align: right;
    }
    input{
      line-height: 70px;
      flex: 1;
      border:2px solid #F57F17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
    .interest-label{
      width: 600px;
    }
    .interest-label.on{
      width: 150px;
      text-align: right;
    }
  }
  .u-input.on{
    flex-direction: column;
    label{
      display: block;
      margin-right: auto;
      text-align: left;
    }
    .ra{
      width:100%;
      line-height:80px;
      padding-left:150px;
    }
  }
  .u-btn{
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #F57F17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on{
  left: 50%;
}
.test-list {
  padding: 32px;
  overflow-x: hidden;
  padding-bottom: changeRem(10)+px;
}

.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all .3s;
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}

.item-inter {
  transform: translateY(0px);
  opacity: 0;
  .ico-box {
    width: changeRem(1.75)+px;
    height: changeRem(1.75)+px;
    border-radius: changeRem(1.75)+px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .pd-row-2 {
    margin-top: 24px;
  }
  .item-text {
    font-size: changeRem(0.6)+px;
  }
  .item-radius {
    border-radius: changeRem(0.17)+px;
  }
  .alert-con {
    overflow: hidden;
  }
  .active_a {
    color: #EB5032;
    text-decoration: underline;
  }
}


/* 左 */

.inter-left {
  .ico-box {
    left: 5px;
    top: 5px;
  }
  .item-text {
    margin-left: changeRem(0.5)+px;
    max-width: 465px;
    color: #fff;
  }
  .alert-con {
    padding: changeRem(0.425)+px;
    background: #F57F17;
  }
  .caret {
    width: 0px;
    height: 0px;
    left: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(245, 127, 23, 0);
    border-right: changeRem(0.3)+px solid rgba(245, 127, 23, 1);
    border-bottom: changeRem(0.2)+px solid rgba(245, 127, 23, 0);
  }
}


/* 右 */

.inter-right {
  .item-text {
    margin-right: changeRem(0.5)+px;
  }
  .alert-con {
    background: #fff;
  }
  .caret {
    width: 0px;
    height: 0px;
    right: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
    border-left: changeRem(0.3)+px solid rgba(255, 255, 255, 1);
    border-bottom: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
  }
  .shelter{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
}

.next-box {
  border-top: 2px solid #fff;
  margin-top: changeRem(0.35)+px;
  padding-top: changeRem(0.35)+px;
}

.item-answer-left-animation {
  animation: item-answer-animation 0.8s;
  animation-fill-mode: forwards;
}

.item-answer-right-animation {
  animation: item-answer-animation 0.8s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}
</style>
<style>
.active {
  color: #EB5032;
  font-weight: bold;
}

.alert-radio-group .van-cell {
  font-size: 0.37rem;
  line-height: 0.64rem;
  position: relative;
  border-bottom: 2px solid #ddd;
}

.alert-radio-group .van-cell:last-child {
  border-bottom: none;
}

.alert-radio-group .van-radio__icon {
  height: 0.55rem;
  line-height: 0.53rem;
}

.alert-radio-group .van-cell__title {
  position: relative;
  z-index: 1;
}

.alert-radio-group .van-radio__icon .van-icon {
  width: 0.53rem;
  height: 0.53rem;
  border-width: 2px;
}

.alert-radio-group [class*=van-hairline]::after {
  border: none;
}

.alert-radio-group .van-cell:not(:last-child)::after {
  border: none;
}

.alert-radio-group .van-cell__title span {
  display: block;
  width: 3.3rem;
  margin-right: -0.6rem;
}


/* 动画 */

@keyframes item-answer-animation {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
